module.exports = __webpack_public_path__ + "static/fonts/Inter-ExtraBold.bd9525f1.ttf";